import { useEffect, useState } from "react";
import { useLocale } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getStoryblokStory } from "@utils/call-api/storyblok-call";
import StoryblokComponent from "@components/core/Storyblok/StoryblokComponent";

const HomeContainer = () => {
  const user = useCurrentUser();
  const locale = useLocale();
  const isLoggedIn = Boolean(user);
  const canPreview = Boolean(user?.permissions?.includes("storyblok"));

  const [story, setStory] = useState();

  useEffect(() => {
    const fetchStoryblokStory = async () => {
      const storySlug = `common/home/${process.env.NEXT_PUBLIC_CUSTOMER}/home`;
      const storyParams = {
        language: locale,
        ...(canPreview && { version: "draft" }),
      };

      const data = await getStoryblokStory(storySlug, storyParams);

      setStory(data.story);
    };

    if (isLoggedIn) fetchStoryblokStory();
  }, [isLoggedIn, canPreview, locale]);

  if (!story) return null;

  return (
    <section className="storyblok-home-container-main">
      <StoryblokComponent story={story} />
    </section>
  );
};

export default HomeContainer;
